(() => {
  function debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
  window._debounce = debounce;

  window.addEventListener("resize", debounce(() => {
    document.dispatchEvent(new CustomEvent('windowResize'));
  }, 300))

  // 公共类可继承open属性
  const GlobalHTMLElement = class extends HTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        (async () => {
          this.setAttribute("open", "");
        })();
      } else {
        this.removeAttribute("open");
      }
    }
    listenerKeydown() {
      document.addEventListener("keydown", (e) => {
        if (this.open && e.code == "Escape") {
          this.open = false;
        }
      });
    }
  };
  // swiper-component 自定义轮播组件
  customElements.define(
    "swiper-component",
    class SwiperComponent extends GlobalHTMLElement {
      custom_pagination = {
        total: 0,
        current: 0,
      };
      swiper_options = {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: false,
        autoplay: false,
        watchOverflow: true,
      };
      constructor() {
        super();
        // 执行一次
        this.lock = true;
        // 自定义切换按钮
        this.custom_prev_btn = this.querySelector(".swiper-pagination-prev");
        this.custom_next_btn = this.querySelector(".swiper-pagination-next");
        this.custom_swiper_tabs = this.querySelectorAll(".swiper-tab-item");
      }
      disconnectedCallback() {
        this.swiper.destroy(true, true);
      }
      connectedCallback() { }
      attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
          case "open":
            if (this.hasAttribute("open") && this.lock) {
              this.lock = false;
              this.startSwiper();
            }
        }
      }
      startSwiper() {
        this.initPagination();
        this.initSwiper();
        // 自定义切换按钮
        this.initCuPaginationButton();
      }

      initSwiper() {
        Object.keys(this.dataset).forEach((key) => {
          this.swiper_options[key] = JSON.parse(this.dataset[key]);
        });
        this.swiper = new Swiper(this.querySelector(".swiper"), {
          ...this.swiper_options,
        });
        this.swiper["custom_pagination"] = this.custom_pagination;
        this.swiper.on("slideChange", (item) => {
          this.custom_pagination["current"] = item.realIndex + 1;
          this.swiper["custom_pagination"] = this.custom_pagination;
          this.updateCuPaginationButton();
          this.selectTabsItem(item.realIndex);
        });
        if (this.dataset.progress) {
          this.querySelector('.swiper').classList.add("swiper-autoplay")
          this.swiper.on("autoplayTimeLeft", (s, time, progress) => {
            this.style.setProperty(`--pagination-progress`, ((1 - progress) * 100).toFixed(0) + '%')
            // 你可以将 progress 用于进度条或圆环展示
          })
        }

      }
      slideTo(index) {
        this.swiper.slideTo(index);
      }

      initPagination() {
        if (
          this.querySelector(".swiper-button-next") &&
          this.querySelector(".swiper-button-prev")
        ) {
          this.swiper_options.navigation = {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          };
        }
        if (this.querySelector(".swiper-pagination")) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          };
        }
        if (
          this.querySelector(
            ".swiper-pagination.swiper-pagination-dynamicBullets"
          )
        ) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            dynamicBullets: true,
          };
        }
        if (this.querySelector(".swiper-pagination-custom")) {
          const _this = this;
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination-custom"),
            clickable: true,
            type: "custom",
            renderCustom: function (swiper, current, total) {
              _this.custom_pagination = {
                current,
                total,
              };
              return null;
            },
          };
        }
      }
      initCuPaginationButton() {
        if (this.custom_next_btn && this.custom_prev_btn) {
          this.updateCuPaginationButton();
          this.custom_prev_btn.onclick = () => {
            this.swiper.slidePrev();
            this.updateCuPaginationButton();
          };
          this.custom_next_btn.onclick = () => {
            this.swiper.slideNext();
            this.updateCuPaginationButton();
          };
        }
        if (this.custom_swiper_tabs.length) {
          this.selectTabsItem(0);
          this.custom_swiper_tabs.forEach((item, index) => {
            item.onclick = () => {
              this.selectTabsItem(index);
            };
          });
        }
      }

      selectTabsItem(index) {
        if (this.custom_swiper_tabs.length) {
          $(this.custom_swiper_tabs)
            .not(this.custom_swiper_tabs[index])
            .removeClass("active");
          this.custom_swiper_tabs[index].classList.add("active");
          this.swiper.slideTo(index);
        }
      }
      updateCuPaginationButton() {
        if (!this.custom_next_btn && !this.custom_prev_btn) return;
        this.custom_prev_btn.disabled = this.swiper.activeIndex == 0;
        this.custom_next_btn.disabled = this.swiper.isEnd;
      }
    }
  );

  // 轮播图上下切换按钮组件(含当前页数)
  customElements.define(
    "swiper-button-pagination",
    class SwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.swiper =
          document.getElementById(this.dataset.sectionId)?.swiper ?? {};
        this.current_dom = this.querySelector(
          ".swiper-button-pagination-current"
        );
        this.total_dom = this.querySelector(".swiper-button-pagination-total");
        this.prev_btn = this.querySelector(".swiper-button-pagination-prev");
        this.next_btn = this.querySelector(".swiper-button-pagination-next");
        this.selectActive();
        this.init();
      }

      init() {
        this.prev_btn.addEventListener("click", () => {
          this.swiper.slidePrev();
        });
        this.next_btn.addEventListener("click", () => {
          this.swiper.slideNext();
        });
        this.swiper.on("slideChange", (item) => {
          this.selectActive();
        });

        window.addEventListener(
          "resize",
          debounce(() => {
            this.selectActive();
          }, 400)
        );
      }
      selectActive() {
        this.current_dom.innerText = this.swiper.custom_pagination.current;
        this.total_dom.innerText = this.swiper.custom_pagination.total;
        this.prev_btn.disabled = this.swiper.activeIndex == 0;
        this.next_btn.disabled = this.swiper.isEnd;
      }
    }
  );

  /**
   * 唤醒弹窗按钮有两种唤醒方式
   * 1. global-modal-button子元素包含template
   * 2. global-modal-button data-id 不为空
   * 
   * */

  customElements.define("global-modal-button", class GlobalModalButton extends HTMLElement {
    constructor() {
      super();
      this.childHtml = this.querySelector('template')?.innerHTML
    }
    connectedCallback() {
      if (this.childHtml || this.dataset.modalId) {
        this.addEventListener("click", this.openGlobalModalHandle)
      } else {
        return new Error("data-modal-id或子元素template不能为空");
      }

    }
    openGlobalModalHandle() {
      console.log("this", this.childHtml)
      const _this = this
      if (_this.childHtml) {
        document.dispatchEvent(new CustomEvent('open-global-modal', {
          bubbles: true,
          detail: {
            childHtml: _this.childHtml,
            modalContentClass: _this.dataset.modalContentClass
          }
        }))
      } else {
        const modalContainer = document.getElementById(this.dataset.modalId);
        modalContainer.toggleAttribute("open");
        modalContainer.hasAttribute('open') ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden")
        if (this.dataset.index) {
          modalContainer?.slideTo(this.dataset.index)
        }

      }

    }
    disconnectedCallback() {
      this.removeEventListener("click", this.openGlobalModalHandle)
    }
  }
  );

  customElements.define(
    "global-modal",
    class GlobalModal extends GlobalHTMLElement {
      constructor() {
        super();
        this.childHtml = null
        this.modalContent = this.querySelector(".global-modal-content")
        this.listenerKeydown();
      }
      connectedCallback() {
        this.addEventListener("click", (e) => {
          if (this.open && (e.target == this || e.target == this.querySelector('.global-modal-close'))) {
            this.removeContent()
          }
        });
        document.addEventListener("open-global-modal", (e) => {
          if (this.childHtml != e.detail.childHtml) {
            this.childHtml = e.detail.childHtml
            this.modalContent.innerHTML = e.detail.childHtml;
            e.detail.modalContentClass && this.modalContent.classList.add(e.detail.modalContentClass)
          }
          this.open = true;
          document.body.classList.add("overflow-hidden")
        })
      }
      removeContent() {
        this.open = false;
        document.body.classList.remove("overflow-hidden")
      }
    }
  );

  // 加购按钮
  customElements.define(
    "add-cart-button",
    class AddCartButton extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.addEventListener("click", () => {
          if (this.hasAttribute("disabled")) return
          this.addToCart(this.dataset.variantId);
        });
      }
      addToCart(variantId) {
        const _this = this;
        let formData = {
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        };
        this.classList.add("button-loading");
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((res) => {
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
              bubbles: true,
            }));
          })
          .catch((error) => {
            console.error("Error:", error);
            alert("Error", JSON.stringify(error))
          })
          .finally(() => {
            _this.classList.remove("button-loading");
          });
      }
    }
  );

  customElements.define(
    "image-lazy-load",
    class ImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.image = this.querySelector(".img--lazyload");
        this.initImageLazyLoad();
      }

      initImageLazyLoad() {
        if ("IntersectionObserver" in window) {
          const lazyImageObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                let lazyImage = entry.target;
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.add("lazyloaded");
                observer.unobserve(entry.target);
                // 重新计算动画位置
                // AOS?.refreshHard()
              }
            });
          });

          lazyImageObserver.observe(this.image);
        } else {
          let active = false;
          const _this = this;
          let lazyLoad = () => {
            if (active === false) {
              active = true;
              setTimeout(() => {
                const lazyImage = _this.image;
                if (
                  lazyImage.getBoundingClientRect().top <= window.innerHeight &&
                  lazyImage.getBoundingClientRect().bottom >= 0 &&
                  getComputedStyle(lazyImage).display !== "none"
                ) {
                  lazyImage.src = lazyImage.dataset.src;
                  // lazyImage.classList.remove("lazy");
                  lazyImage.classList.add("lazyloaded");
                }
                active = false;
              }, 200);
            }
          };
          document.addEventListener("scroll", lazyLoad);
          window.addEventListener("resize", lazyLoad);
          window.addEventListener("orientationchange", lazyLoad);
        }
      }
    }
  );
  customElements.define(
    "bg-image-lazy-load",
    class BgImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.bgElements = this.querySelectorAll(".bg-lazyload");
        this.init();
      }
      init() {
        if ("IntersectionObserver" in window) {
          const lazyObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                let element = entry.target;
                element.style.backgroundImage = `url(${element.dataset.src})`;
                observer.unobserve(entry.target);
              }
            });
          });
          this.bgElements.forEach((item) => {
            lazyObserver.observe(item);
          });
        } else {
          this.bgElements.forEach((item) => {
            item.style.backgroundImage = `url(${item.dataset.src})`;
          });
        }
      }
    }
  );
  class VideoLazyLoad extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.video = this.querySelector(".video--lazyLoad");
      // 人机是否有交互
      this.interactState = false;
      this.autoplayMap = [];
      // this.listenerIntersectionObserver()
      this.listenerInteract();
      this.listenerALick();
    }

    listenerIntersectionObserver() {
      const _this = this;
      this.videoObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach((entry) => {
          let video = entry.target;
          if (entry.isIntersecting) {
            video.src = video.dataset.src;
            if (video.dataset.poster) {
              video.poster = video.dataset.poster;
            }
            if (video.dataset.autoplay) {
              // 有交互性则自动播放
              video.play();
              // _this.interactState ? video.play() : _this.autoplayMap.push(video)
            }

            // observer.unobserve(entry.target);
          } else {
            // 不在可视区暂停播放
            video.src && video.pause();
          }
        });
      });

      this.videoObserver.observe(this.video);
      //   this.videos.forEach((item) => {
      //     this.videoObserver.observe(item);
      //   });
    }
    listenerInteract() {
      const startEvent = () => {
        this.listenerIntersectionObserver();
        // this.interactState = true
        // this.autoplayMap.forEach(video => video.play())
      };
      document.addEventListener("mousemove", startEvent, { once: true });
      document.addEventListener("touchstart", startEvent, { once: true });
    }

    listenerALick() {
      document.addEventListener("click", (event) => {
        if (
          event.target.tagName === "A" &&
          event.target.getAttribute("href") &&
          this.video
        ) {
          //   this.videos.forEach((video) => video.pause());
          this.video.pause();
        }
      });
    }
  }
  customElements.define("video-lazy-load", VideoLazyLoad);

  customElements.define(
    "global-tabs",
    class SectionPartnersContent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = this.querySelectorAll(".global-tab");
        this.currentItem = this.tabs[0]
        this.updateSlider();

        const swiperContainer = document.querySelector(
          "#" + this.dataset.swiperId
        )?.swiper;

        swiperContainer.on("slideChange", (e) => {
          this.currentItem = this.tabs[e.activeIndex]
          this.updateSlider();
        });
        this.tabs.forEach((item, index) => {
          item.addEventListener("click", () => {
            if (this.currentItem == item) return
            swiperContainer.slideTo(index);
            this.currentItem = item
            this.updateSlider();
          });
        });

        document.addEventListener("windowResize", () => {
          this.updateSlider()
        })
      }
      updateSlider() {
        this.currentItem.classList.add("active");
        $(this.tabs).not(this.currentItem).removeClass("active");
        const { offsetLeft, offsetWidth } = this.currentItem;
        $(this).css({
          ["--global-tab-left"]: offsetLeft + "px",
          ["--global-tab-width"]: offsetWidth + "px",
        });
      }
    }
  );
  customElements.define(
    "subscribe-email",
    class SubscribeEmail extends HTMLElement {
      constructor() {
        super();
        if (this.dataset.isSticky == "true") {
          this.sticky_container = this.parentNode;
          this.setParentStyle();
          this.init();
        }
      }
      setParentStyle() {
        this.sticky_container.style.cssText =
          "position: sticky;top: 0;z-index: 10;";
      }
      init() {
        let intervalCount = 0;
        let time = setInterval(() => {
          let epb_background = document.querySelector("#epb_background");
          intervalCount++;
          if (epb_background || intervalCount >= 30) {
            if (
              epb_background &&
              ["fixed", "sticky"].includes(epb_background.style.position)
            ) {
              this.listenerRpbCountdownCreate(epb_background);
            }
            clearInterval(time);
          }
        }, 1000);
      }

      listenerRpbCountdownCreate(epb_background) {
        let sticky_top = epb_background.getBoundingClientRect()?.height ?? 0;
        this.sticky_container.style.top = sticky_top + "px";
        epb_background
          .querySelector("#epb_close")
          ?.addEventListener("click", () => {
            this.sticky_container.style.top = 0;
          });
      }
    }
  );

  customElements.define(
    "faq-conetnt",
    class FaqConetnt extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const itemTitles = this.querySelectorAll(".section-faq-item-title");
        itemTitles.forEach((item) => {
          item.addEventListener("click", () => {
            item.classList.toggle("active");
            $(item.nextElementSibling).slideToggle();
          });
        });
      }
    }
  );
  customElements.define("youtube-lazy-load", class YoutubeLazyLoad extends HTMLElement {
    constructor() {
      super()
      this.youtubeSection = this.querySelector('.youtube-lazy--section')
      this.createScript()
      document.addEventListener("youTubeReady", () => {
        this.scrollView()
      })
    }
    scrollView() {
      const _this = this
      const observer = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!entry.target.playVideo) {
              _this.init(entry.target)
            }
          } else {
            entry.target.pauseVideo?.()
          }
        });
      });
      observer.observe(this.youtubeSection)
    }
    init(section) {
      if (section.playVideo) return;
      if (window.YT) {
        const target = section.querySelector('.youtube-lazy--load')
        const playe = new window.YT.Player(target, {
          ...target.dataset
        });
        section.playVideo = function () {
          playe.playVideo?.()
        }
        section.pauseVideo = function () {
          playe.pauseVideo?.()
        }
      }
    }
    disconnectedCallback() {
      // this.modalContainer.removeEventListener("click")
    }

    createScript() {
      const scriptTags = Array.from(document.getElementsByTagName('script'));
      const youtubeScript = scriptTags.find(t => t.src == "https://www.youtube.com/player_api")
      if (!youtubeScript) {
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        scriptTags[0].parentNode.insertBefore(tag, scriptTags[0]);
      } else {
        this.scrollView(this)
      }
    }
  })

  customElements.define("slide-navs", class SlideNavs extends HTMLElement {
    constructor() {
      super()
      this.targetElements = []
      this.swiper = this.querySelector("swiper-component")?.swiper ?? {}
      this.header = document.querySelector(".header__container")
      this.navContainer = document.querySelector(".slide-navs__container")
      this.init()
      this.listenerScroll()
    }
    init() {
      this.slides = Array.from(this.querySelectorAll(".slide-navs--item"))
      this.slides.forEach((t, index) => {
        this.targetElements.push(document.getElementById(t.dataset.targetId))
        t.onclick = () => {
          // this.selectActive(index)
          this.toTarget(index)
        }
      })
    }
    selectActive(index) {
      const currentItem = this.slides[index]
      this.slides.filter(p => p != currentItem).forEach(p => p.classList.remove('active'))
      currentItem.classList.add("active")
    }
    listenerScroll() {
      window.addEventListener(
        "scroll",
        () => {
          this.targetElements.forEach((t, index) => {
            if (t.getBoundingClientRect().top < 50) {
              this.selectActive(index)
              this.swiper?.slideTo(index)
            }
          })
          if (this.header) {
            this.updateElementTopValue()
          }
        }
      );
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.navContainer.style.top = 0
        this.header.style.top = `-${this.header.clientHeight}px`
      } else {
        this.header.style.top = 0
        this.navContainer.style.top = `${this.header.clientHeight}px`
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop();
      let delta = scrollY - this.curScrollY;
      this.curScrollY = scrollY
      return delta > 0;
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }
    toTarget(index) {
      const anchor = this.targetElements[index]
      anchor.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  })

  customElements.define("content-slides", class ContentSlides extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const swiperContainer = document.querySelector(
        "#" + this.dataset.swiperId
      )?.swiper;

      const swiper = this.querySelector("swiper-component").swiper

      swiperContainer.on("slideChange", (e) => {
        // this.updateSlider(this.tabs[e.activeIndex]);
        swiper.slideTo(e.activeIndex)
      });
    }
  })

  customElements.define("product-params-modal", class ProductParamsModal extends HTMLElement {
    constructor() {
      super()
      this.closeBtn = this.querySelector('.close-modal')
      this.init()
    }
    init() {
      if (!this.id) return
      this.closeBtn.onclick = () => {
        this.closeModla()
      }
      this.navSwiper = this.querySelector("#nav-" + this.id).swiper
      this.slides = this.navSwiper.slides
      this.contentSwiper = this.querySelector("#content-" + this.id).swiper
      this.navSwiper.on("tap", (swiper) => {
        this.slideTo(swiper.clickedIndex)
      })

    }
    slideTo(i) {
      let index = Number(i ?? 0)
      let currentSlide = this.slides[index]
      this.navSwiper.slideTo(index)
      this.contentSwiper.slideTo(index)
      this.slides.filter(t => t != currentSlide).forEach(t => t.classList.remove('active'))
      currentSlide.classList.add("active")
    }
    closeModla() {
      this.removeAttribute("open");
      document.body.classList.remove('overflow-hidden')
    }
  })


  /**
   * 数字滚动
   * data-target
   */
  customElements.define(
    "scroll-number",
    class ScrollNumber extends HTMLElement {
      constructor() {
        super();
        // 滚动时长
        this.duration = 4000
        this.init()
      }
      init() {
        this.querySelectorAll(".count--number").forEach((element) => {
          const number = parseInt(element.dataset.number ?? 0, 10);
          const duration = parseInt(element.dataset.duration ?? this.duration, 10);
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (element.dataset.type) {
                    element.style.setProperty(`--number-${element.dataset.type}`, "100%")
                  } else {
                    this.animateNumber(entry.target, number, duration);
                  }
                  // observer.unobserve(entry.target); // 触发后取消观察
                } else {
                  element.style.setProperty(`--number-${element.dataset.type}`, "0%")
                }
              });
            },
            { threshold: 0.5 }
          ); // 当元素 50% 进入视口时触发

          observer.observe(element);
        });
      }
      animateNumber(element, number, duration) {
        let startTimestamp = null;

        // 缓动函数集合
        const easingFunctions = {
          // 默认线性（无缓动）
          linear: (progress) => progress,

          // 加速后减速（标准缓动）
          easeInOutQuad: (progress) => {
            return progress < 0.5
              ? 2 * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 2) / 2;
          },

          // 结尾减速（常用效果）
          easeOutQuad: (progress) => {
            return 1 - (1 - progress) * (1 - progress);
          },

          // 弹性效果
          easeOutElastic: (progress) => {
            const c4 = (2 * Math.PI) / 3;
            return progress === 0
              ? 0
              : progress === 1
                ? 1
                : Math.pow(2, -10 * progress) *
                Math.sin((progress * 10 - 0.75) * c4) +
                1;
          },
        };

        const updateNumber = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp;

          const elapsed = timestamp - startTimestamp;
          const rawProgress = Math.min(elapsed / duration, 1);

          // 使用缓动函数（这里选择 easeOutQuad）
          const easedProgress = easingFunctions.easeInOutQuad(rawProgress);
          const current = Math.floor(easedProgress * number);

          this.updateElement(element, current)
          if (rawProgress < 1) {
            requestAnimationFrame(updateNumber);
          } else {
            this.updateElement(element, number)
          }
        };
        requestAnimationFrame(updateNumber);
      }
      updateElement(element, number) {
        if (element.dataset.type) {
          element.style.setProperty(`--number-${element.dataset.type}`, number + "%")
        } else {
          element.textContent = number;
        }
      }
    }
  );


  customElements.define("return-top", class ReturnTop extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      this.onclick = () => {
        document.body.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
      document.addEventListener("scroll", () => {
        this.getScrollTop() >= 300 ? (this.classList.remove('return-top-hidden')) : (this.classList.add("return-top-hidden"))
      })
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }
  })

  customElements.define("header-navigation", class headerNavigation extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.menuItems = Array.from(this.querySelectorAll(".header-menu-item"));
      this.menuItems.forEach((item) => {
        const leftNavs = Array.from(item.querySelectorAll(".header-menu-item-left-nav"));
        const contents = Array.from(item.querySelectorAll(".header-menu-item-content"));
        if (!leftNavs.length) return;
        item.addEventListener("mouseenter", () => {
          if (!leftNavs.find(t => t.classList.contains("active"))) {
            leftNavs[0].classList.add("active");
            contents[0].classList.add("active");
          }
          leftNavs.forEach((leftNav, index) => {
            leftNav.addEventListener("mouseenter", () => {
              leftNavs.forEach((nav, i) => {
                if (i !== index) {
                  nav.classList.remove("active");
                  contents[i].classList.remove("active");
                }
              });
              leftNav.classList.add("active");
              contents[index].classList.add("active");
            });
          });
        });

      });
    }
  });

  customElements.define("header-navigation-mobile", class headerNavigationMobile extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.initControls()
    }
    init() {
      const menuMobiles = Array.from(this.querySelectorAll(".menu-mobile"));
      const menuSubMobile = Array.from(this.querySelectorAll(".menu-sub-mobile"));
      const menuSubMobileItems = Array.from(this.querySelectorAll(".menu-link-mobile-item"));
      this.menuMobiles = menuMobiles
      this.selectItem(menuMobiles)
      this.selectItem(menuSubMobile)
      this.selectItem(menuSubMobileItems)
    }
    selectItem(list) {
      list.forEach((item) => {
        item.onclick = () => {
          $(item).toggleClass('active').next().slideToggle(300)
        }
      })
    }

    initControls() {
      new theme.CartDrawer();
      document.querySelector("#header-menu-mobile-open")?.addEventListener("click", () => {
        this.setAttribute("open", '')
      })
      this.querySelector(".header-navigation-mobile-close")?.addEventListener("click", () => {
        this.removeAttribute("open")
      })



      //predictive-search:close-all
      document.addEventListener("predictive-search:close-all", () => {
        document.querySelector(".site-header__search-container").classList.remove('is-active');
      })

      const search_btn = document.querySelector('#header-menu-icon-search')
      search_btn?.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        document.dispatchEvent(
          new CustomEvent('predictive-search:open', {
            detail: {
              context: 'header',
            },
            bubbles: true,
          })
        );
        // add is-active class to .site-header__search-container
        document.querySelector('.site-header__search-container').classList.add('is-active');
      });

    }
  })

})();
